<lib-dba-mat-dialog-title (cancelClick)="dialogRef.close()">
  {{Title}}
</lib-dba-mat-dialog-title>

<mat-dialog-content [formGroup]="FormGroup">
  @if(loading){<lib-spinner-dialog></lib-spinner-dialog>}

  <lib-select-create formControlName="objektControl" [selectList]="objektList" selectValue="ObjektID"
    [selectNameList]="['DebitorNummer','DebitorName','Bezeichnung','PLZ','Ort','LandName']" [styleList]="styleList"
    [label]="language.objekt | translationPipe" [showDeselect]="false" [showCreate]="false" [required]="true">
  </lib-select-create>

  <div class="row">
    <mat-form-field>
      <mat-label>{{language.LaufzeitVon | translationPipe}}</mat-label>
      <input matInput formControlName="laufzeitvonControl" [matDatepicker]="laufzeitvon">
      <mat-datepicker-toggle matIconSuffix [for]="laufzeitvon"></mat-datepicker-toggle>
      <mat-datepicker #laufzeitvon></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{language.LaufzeitBis | translationPipe}}</mat-label>
      <input matInput formControlName="laufzeitbisControl" [matDatepicker]="laufzeitbis">
      <mat-datepicker-toggle matIconSuffix [for]="laufzeitbis"></mat-datepicker-toggle>
      <mat-datepicker #laufzeitbis></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{language.Intervall | translationPipe}}</mat-label>
      <input matInput formControlName="intervallControl" type="number" max="36" step="1">
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{language.Rhythmus | translationPipe}}</mat-label>
        <mat-select formControlName="ServiceRythmusControl">
        @for (rythmus of rythmusList; track rythmus) {
            <mat-option [value]=rythmus>{{rythmus.Servicerythmus}}</mat-option>
        }    
        </mat-select>
    </mat-form-field>           
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <lib-dba-mat-dialog-footer (cancelClick)="dialogRef.close()" (saveClick)="Save()"></lib-dba-mat-dialog-footer>
</mat-dialog-actions>